import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Product } from "./product.model";

@Injectable()
export class ProductService extends CrudService {
  getRootUrl(): string {
    return "products";
  }

  save(product: Product) {
    return super.save(product);
  }

  saveMultiple(products: Array<Product>) {
    return super.saveMultiple(products);
  }

  savePositions(products: Array<Product>) {
    return super.saveMultiple(
      products.map((item) => {
        return {
          _id: item._id,
          position: item.position,
        };
      })
    );
  }

  getParents() {
    return this.http.get(`/${this.rootUrl}/parents`).map(this.http.getJsonData);
  }

  sendToStore(product: Product) {
    const id = product._id;
    return this.http
      .get(`/${this.rootUrl}/${id}/send-to-store`)
      .map(this.http.getJsonData);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/product.service.ts